import { render, staticRenderFns, recyclableRender, components } from "./chapter-test.vue?vue&type=template&id=a91df5d2&scoped=true&"
var renderjs
import script from "./chapter-test.vue?vue&type=script&lang=js&"
export * from "./chapter-test.vue?vue&type=script&lang=js&"
import style0 from "./chapter-test.vue?vue&type=style&index=0&id=a91df5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91df5d2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/chapter-test.vue"
export default component.exports